import React from 'react';
import { Box, Paper, Typography, IconButton, Divider, Alert } from '@mui/material';
import { Close as CloseIcon, SmartToy as BotIcon } from '@mui/icons-material';
import ChatMessageList from './ChatMessageList';
import ChatInput from './ChatInput';
import { PANEL_PAPER_SX, HEADER_SX } from './constants';

const ChatPanel = ({
  open,
  onClose,
  showClose = true,
  paperSx,
  messages,
  loading,
  messagesEndRef,
  showEmptyChips,
  suggestionChips,
  onChipSelect,
  inputValue,
  setInputValue,
  onSend,
  onKeyDown,
  errorText,
  showRetry,
  onRetry,
  welcomeChipLabels,
  loadingHint,
}) => {
  if (!open) return null;

  const paperStyles = paperSx != null ? paperSx : PANEL_PAPER_SX;

  const errorBanner = errorText ? (
    <Alert severity="error" sx={{ py: 0.5, mb: 1, '& .MuiAlert-message': { width: '100%' } }}>
      {errorText}
    </Alert>
  ) : null;

  return (
    <Paper elevation={0} sx={paperStyles}>
      <Box sx={HEADER_SX}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, minWidth: 0 }}>
          <BotIcon fontSize="small" sx={{ mt: 0.25, flexShrink: 0 }} />
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight={600} lineHeight={1.3}>
              Privacy Assistant
            </Typography>
            <Typography variant="caption" sx={{ color: 'rgba(4, 33, 29, 0.75)', display: 'block', mt: 0.25 }}>
              Answers from your SafeSocial data only — not legal advice.
            </Typography>
          </Box>
        </Box>
        {showClose ? (
          <IconButton size="small" onClick={onClose} sx={{ color: '#04211D', flexShrink: 0 }} aria-label="Close assistant">
            <CloseIcon fontSize="small" />
          </IconButton>
        ) : (
          <Box sx={{ width: 40, flexShrink: 0 }} aria-hidden />
        )}
      </Box>

      <Divider />

      <ChatMessageList
        messages={messages}
        loading={loading}
        loadingHint={loadingHint}
        messagesEndRef={messagesEndRef}
        showEmptyChips={showEmptyChips}
        welcomeChipLabels={welcomeChipLabels}
        suggestionChips={suggestionChips}
        onChipSelect={onChipSelect}
        errorBanner={errorBanner}
      />

      <Divider />

      <ChatInput
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={onKeyDown}
        onSend={onSend}
        loading={loading}
        showRetry={showRetry}
        onRetry={onRetry}
        disabledSend={!inputValue.trim() || loading}
      />
    </Paper>
  );
};

export default ChatPanel;
